import { useState, useEffect } from "react";
import { Layout } from "antd";
import {
  Routes,
  Route,
  useNavigate,
  // useLocation,
} from "react-router-dom";
import toastr from "toastr";
import { UserServiceApi } from "../api";
import { getRequest } from "../api/http";
import { LoadingView, RequireAuth } from "./common";
import TopMenu from "./header/headerWithAuth/TopMenu";
// import Chat from "./chat";

import InternetError from "./common/internetError";
//Placement officer screens
import Event from "./PlacementOfficer/Event/Event.jsx";
import PlacementHome from "./PlacementOfficer/PlacementHome/PlacementHome";
import Employer from "./PlacementOfficer/EmployerList/Employer.jsx";
import StudentList from "./PlacementOfficer/StudentList/StudentList.jsx";
import CreateEvent from "./PlacementOfficer/Event/CreateEvent.jsx";
import EmployerbyId from "./PlacementOfficer/EmployerList/EmployerbyId.jsx";
import StudentHistory from "./PlacementOfficer/StudentList/StudentHistory";
import ResumeViewPO from "./PlacementOfficer/StudentList/ResumeViewPO";
import StudentsUnderJobs from "./PlacementOfficer/JobsUnderEvent/studentsUnderJobs.jsx";
import JobDetailPO from "./PlacementOfficer/JobsUnderEvent/jobDetailPO";
import PoProfile from "./PlacementOfficer/PoProfile.jsx";
import PageNotFound from "./common/pageNotFound";
import ResetPassword from "./resetPassword";
import HeaderCA from "./header/headerWithAuth/HeaderCA";
import HomeCA from "./CampusAmbassdor/HomeCA";
import OtpPage from "./login/OtpPage";
import Task from "./CampusAmbassdor/Tasks/Task";
import TaskInfo from "./CampusAmbassdor/Tasks/TaskInfo";
import Rewards from "./CampusAmbassdor/Rewards";

const { Header, Content } = Layout;

toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: "toast-top-center",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

function AppMain() {
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();
  // const location = useLocation();
  const isAuthenticated = localStorage.getItem("token");
  const [isInternetStatus, setIsInternetStatus] = useState(true);

  useEffect(() => {
    function changeStatus() {
      setIsInternetStatus(navigator.onLine);
    }
    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  const handleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const fetchUserDetails = async () => {
    try {
      setLoading(true);
      const response = await getRequest(UserServiceApi.getUserDetails());
      setUserRole(response?.role);
      localStorage.setItem("user", JSON.stringify(response));
      localStorage.setItem("role", response?.role);
      setUser(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);
  // console.log(userRole);

  const refreshFunction = () => {
    fetchUserDetails();
  };
  // useEffect(() => {
  //   const unauthorizedError = () => {
  //     setUser({});
  //     localStorage.removeItem("userBgColor");
  //     localStorage.removeItem("token");
  //     localStorage.removeItem("role");
  //     localStorage.clear();
  //     window.fcWidget.destroy();
  //     navigate("/login", { state: { from: location } });
  //   };
  //   document.addEventListener("unauthorizedError", unauthorizedError);
  //   return () => {
  //     document.removeEventListener("unauthorizedError", unauthorizedError);
  //   };
  // }, [location, navigate]);

  if (!isAuthenticated) {
    navigate("/login");
  }

  if (loading) return <LoadingView />;

  if (!isInternetStatus) return <InternetError />;

  return (
    <div>
      <Header className="header">
        <div className="headerContainer">
          <TopMenu
            collapsed={collapsed}
            user={user}
            handleCollapse={handleCollapse}
          />
          {userRole === "STUDENT" ? (
            <HeaderCA />
          ) : null}
          {/* {userRole && userRole === "ADMIN" ? (
            <HeaderAdminMenu />
          ) : userRole === "EMPLOYER" ? (
            <HeaderBottomMenu />
          ) : userRole === "SUB_ADMIN" ? (
            <HeaderSubAdmin />
          ) : userRole === "EMPLOYER_ADMIN" ? (
            <HeaderEmployerAdminMenu />
          ) : userRole === "JOBSEEKER_ADMIN" ? (
            <HeaderJobseekerAdminMenu />
          ) : null} */}
        </div>
      </Header>

      <Layout
        className={
          userRole && userRole === "PLACEMENT_OFFICER"
            ? "placementofficerLayoutStyle"
            : "layoutStyle"
        }
      >
        <Content>
          <Routes>

            {userRole && userRole === "PLACEMENT_OFFICER" ? (
              <>
                <Route
                  path="/"
                  element={
                    <RequireAuth user={user}>
                      <Event user={user} />
                    </RequireAuth>
                  }
                />
                {/* <Route
                  path="/home"
                  element={
                    <RequireAuth user={user}>
                      <AdminHome user={user} />
                    </RequireAuth>
                  }
                /> */}
                <Route
                  path="/ResetPassword"
                  element={
                    <RequireAuth user={user}>
                      <ResetPassword user={user} />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/Event"
                  element={
                    <RequireAuth user={user}>
                      <Event user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/home/:eventId"
                  element={
                    <RequireAuth user={user}>
                      <PlacementHome user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/pemployers"
                  element={
                    <RequireAuth user={user}>
                      <Employer user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/pstudents"
                  element={
                    <RequireAuth user={user}>
                      <StudentList user={user} />
                    </RequireAuth>
                  }
                />
                {/* <Route
                    path="/merchant"
                    element={
                      <RequireAuth user={user}>
                        <Merchant user={user} />
                      </RequireAuth>
                    }
                  /> */}

                <Route
                  path="/EmpByID/:empId"
                  element={
                    <RequireAuth user={user}>
                      <EmployerbyId user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/CreateEvent"
                  element={
                    <RequireAuth user={user}>
                      <CreateEvent user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/view-profile/:stdid"
                  element={
                    <RequireAuth user={user}>
                      <ResumeViewPO user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/phistory/:studentId"
                  element={
                    <RequireAuth user={user}>
                      <StudentHistory user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/status/:jobid"
                  element={
                    <RequireAuth user={user}>
                      <StudentsUnderJobs user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/job/:jobid"
                  element={
                    <RequireAuth user={user}>
                      <JobDetailPO user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <RequireAuth user={user}>
                      <PoProfile
                        user={user}
                        refreshFunction={refreshFunction}
                      />
                    </RequireAuth>
                  }
                />
                <Route path="*" element={<PageNotFound />} />
              </>
            ) :  userRole === "STUDENT" ?(
              <>
              <Route
                  path="/"
                  element={
                    <RequireAuth user={user}>
                      <HomeCA user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/home"
                  element={
                    <RequireAuth user={user}>
                      <HomeCA user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/tasks"
                  element={
                    <RequireAuth user={user}>
                      <Task user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/task-info"
                  element={
                    <RequireAuth user={user}>
                      <TaskInfo user={user} />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/rewards"
                  element={
                    <RequireAuth user={user}>
                      <Rewards user={user} />
                    </RequireAuth>
                  }
                />
                <Route path="*" element={<PageNotFound />} />
              </>
            ):(
              navigate("/login")
            )}
          </Routes>
        </Content>
      </Layout>
    </div>
  );
}

export default AppMain;
